import React from "react";
import { Search, Plus, X, Dumbbell, Loader2, RefreshCw } from "lucide-react";

const ExerciseSearchPanel = ({
  searchQuery,
  onSearchChange,
  filteredExercises,
  onSelectExercise,
  onClose,
  isReplacing,
  onAddExerciseClick,
  isOpen,
  exercisesLoading,
  totalExercises = 0,
  onRetryLoad,
}) => {
  if (!isOpen) {
    return (
      <div className="text-center py-6 text-gray-500">
        <Dumbbell className="w-10 h-10 mx-auto mb-2 opacity-50" />
        <p className="mb-2">No exercise selected</p>
        <button
          type="button"
          onClick={onAddExerciseClick}
          className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 mx-auto"
          data-testid="add-exercise-btn"
        >
          <Plus className="w-4 h-4" /> Add Exercise
        </button>
      </div>
    );
  }

  return (
    <div className="p-3 border border-[#1E293B] bg-[#0B0F1A] rounded-lg mb-3">
      {isReplacing && (
        <div className="flex items-center justify-between mb-3 bg-amber-500/10 border border-amber-500/30 rounded-lg px-3 py-2">
          <span className="text-amber-400 text-sm font-medium">Replacing exercise</span>
          <button type="button" onClick={onClose} className="text-amber-400 hover:text-amber-300">
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search exercises..."
          className="w-full bg-[#1E293B] border border-[#1E293B] rounded-lg pl-10 pr-4 py-2 text-white focus:border-primary outline-none"
          autoFocus
          data-testid="exercise-search-input"
        />
      </div>
      {totalExercises > 0 && (
        <p className="text-xs text-gray-500 mt-1 px-1">{totalExercises} exercises available</p>
      )}
      <div className="mt-2 max-h-48 overflow-y-auto">
        {exercisesLoading ? (
          <div className="flex items-center justify-center gap-2 py-4 text-gray-400 text-sm">
            <Loader2 className="w-4 h-4 animate-spin" /> Loading exercises...
          </div>
        ) : filteredExercises.length > 0 ? (
          filteredExercises.map((ex) => (
            <button
              key={ex.exercise_id}
              type="button"
              onClick={() => onSelectExercise(ex)}
              className="w-full text-left px-3 py-2 hover:bg-[#2D3B4F] rounded-lg flex items-center justify-between"
              data-testid={`select-exercise-${ex.exercise_id}`}
            >
              <span>{ex.name}</span>
              <Plus className="w-4 h-4 text-primary" />
            </button>
          ))
        ) : (
          <div className="text-center py-3">
            <p className="text-gray-500 text-sm">
              {searchQuery.trim()
                ? totalExercises === 0
                  ? "Exercises failed to load"
                  : "No exercises match"
                : "Start typing to search..."}
            </p>
            {totalExercises === 0 && searchQuery.trim() && onRetryLoad && (
              <button
                type="button"
                onClick={onRetryLoad}
                className="mt-2 flex items-center gap-1.5 text-primary text-sm font-medium hover:underline mx-auto"
                data-testid="retry-load-exercises-btn"
              >
                <RefreshCw className="w-3.5 h-3.5" /> Retry loading exercises
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExerciseSearchPanel;
